import { Grid } from '@mui/material';
import { BasicButton } from '@tassat/button';
import { Minimize } from '@tassat/icon';
import { AccountBalancesCurrencyTile } from '@tassat/text';
import { noop } from 'lodash';
import React, { useState } from 'react';

import { ActionOverlay } from 'SharedComponents/layouts/overlays';

import { AssetListProps } from './types';

const AssetList = (props: AssetListProps) => {
    const {
        goBack,
        classes,
        assetListBalances,
        navPrice
    } = props;

    const [ expandedTiles, setExpandedTiles ] = useState<string[]>([]);

    const handleTileExpansion = (key: string) => () => {
        setExpandedTiles((prevState) => (prevState.includes(key) ?
            prevState.filter((expandedId) => expandedId !== key)
            : [ ...prevState, key ]));
    };

    return (
        <ActionOverlay
            admin={false}
            className={classes.root}
            goBack={goBack ?? noop}
            title='DASHBOARD'
        >
            <Grid
                className={classes.fullWidth}
                container
            >
                <Grid className={classes.assetTitleContainer}>
                    <Grid
                        className={classes.buttonContainer}
                        container
                        item
                        justifyContent='flex-end'
                        xs={12}
                    >
                        <Grid item>
                            <BasicButton
                                className={classes.minimizeButton}
                                Icon={Minimize}
                                onClick={() => setExpandedTiles([])}
                                text='Minimize All'
                                type='mainSmall'
                            />
                        </Grid>
                    </Grid>
                    <Grid
                        className={classes.assetsContainer}
                        container
                        direction='column'
                        item
                        wrap='nowrap'
                        xs={12}
                    >
                        {assetListBalances && assetListBalances.map((item, index) => (
                            <Grid
                                className={classes.assetTile}
                                item
                                key={item.currency?.AlphabeticCode ?? index}
                            >
                                <AccountBalancesCurrencyTile
                                    {...item}
                                    allowControlledInput
                                    expandedItems={expandedTiles}
                                    navPrice={navPrice[item.currency.AlphabeticCode]}
                                    onChange={handleTileExpansion}
                                    showPrice={!!navPrice[item.currency.AlphabeticCode]}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </Grid>
        </ActionOverlay>
    );
};

export default AssetList;